import styled from "@emotion/styled"

const ArticleRelatedArticleInfoAuthorName = styled.span`
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
`

export default ArticleRelatedArticleInfoAuthorName